import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'src/components/app-ui'

const useStyles = makeStyles({
  // Trigger buttons
  headButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 16px',
    border: 0,
    borderRadius: '8px',
    background: colors.primarySoft,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: '14px',
    fontWeight: 500,
    color: colors.primary,
    '&:hover': {
      background: '#D6E6FF',
    },
  },
  pathButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
    '&:hover': {
      background: 'rgba(1,95,251,.08)',
    },
  },

  // Menu
  menu: {
    width: 300,
    marginTop: 6,
    padding: '6px',
    border: `1px solid ${colors.border}`,
    borderRadius: '12px',
    boxShadow:
      '0 20px 40px -4px rgba(145,158,171,.28), 0 0 2px rgba(145,158,171,.2)',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  menuItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '10px',
    border: 0,
    borderRadius: '10px',
    background: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    fontFamily: 'inherit',
    '&:hover': {
      background: colors.hover,
    },
  },
  menuIcon: {
    width: 36,
    height: 36,
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
  },
  menuText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: 0,
  },
  menuTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: colors.navy,
  },
  menuDesc: {
    fontSize: '12px',
    lineHeight: 1.45,
    color: colors.muted,
    whiteSpace: 'normal',
  },

  // Create from scratch modal
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 1300,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'rgba(0,0,0,.48)',
  },
  dialog: {
    width: '100%',
    maxWidth: 520,
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    padding: '24px',
    borderRadius: '16px',
    background: '#FFFFFF',
    boxShadow: '0 20px 40px -4px rgba(145,158,171,.24)',
    fontFamily: "'Inter', system-ui, sans-serif",
    color: colors.navy,
  },
  dialogHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
  },
  dialogTitle: {
    fontSize: '18px',
    fontWeight: 600,
  },
  dialogSub: {
    marginTop: 2,
    fontSize: '13px',
    color: colors.muted,
  },
  close: {
    display: 'flex',
    padding: 4,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    color: colors.muted,
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },
  input: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '11px 12px',
    border: '1px solid rgba(145,158,171,.32)',
    borderRadius: '8px',
    outline: 'none',
    background: '#FFFFFF',
    fontFamily: 'inherit',
    fontSize: '14px',
    color: colors.navy,
    '&:focus': {
      borderColor: colors.primary,
    },
  },
  selectWrap: {
    position: 'relative',
    display: 'flex',
  },
  select: {
    appearance: 'none',
    WebkitAppearance: 'none',
    paddingRight: 36,
    cursor: 'pointer',
  },
  selectChevron: {
    position: 'absolute',
    top: '50%',
    right: 12,
    transform: 'translateY(-50%)',
    display: 'inline-flex',
    pointerEvents: 'none',
    color: colors.muted,
  },
  hint: {
    fontSize: '12px',
    fontWeight: 400,
    color: colors.muted,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
  },
  textButton: {
    padding: '9px 14px',
    border: 0,
    borderRadius: '8px',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.muted,
  },
  primaryButton: {
    padding: '9px 18px',
    border: 0,
    borderRadius: '8px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: '#FFFFFF',
  },
})

export default useStyles
